import { QuestionBase } from './question-base';

export class ToggleQuestion extends QuestionBase<string> {
  controlType = 'toggle';

  constructor(options: any = {}) {
    super(options);
    this.value = options['value'] || false;
  }
}
